import ScrollToLink from './modules/scroll-to-link';
import Masthead from './modules/masthead';
import DarkModeToggle from './modules/dark-mode-toggle';
import DrawerToggle from './modules/drawer-toggle';
import Loader from './modules/loader';
import YoutubeVideoLightbox from './modules/youtube-video-lightbox';
import VimeoVideoLightbox from './modules/vimeo-video-lightbox';
import Share from './modules/share';
import GallerySlider from './modules/gallery-slider';
import Speakers from './modules/speakers';
import Snapshots from './modules/snapshots';
import MailchimpFormModal from './modules/mailchimp-form-modal';
import SaveTheDateModal from './modules/save-the-date-modal';
import CTAModal from './modules/cta-modal';
import Lightbox from './modules/lightbox';
import Carousel from './modules/carousel';
import Menu from './modules/menu';
import ScrollToSummitGallery from './modules/scroll-to-summit-gallery';
import { announceEnqueued } from './modules/utils';
import BackToTop from './modules/back-to-top';
import SearchPopper from './modules/search-popper';
import Hero from './modules/hero';
import MailchimpForm from './modules/mailchimp-form';
import SubscriptionSuccess from './modules/subscription-success';

(function() {

	// construct classes
	const loader = new Loader(document.getElementById('loader'));
	const masthead = new Masthead(document.getElementById('masthead'));
	const darkModeToggle = new DarkModeToggle(document.getElementById('dark-mode-toggle'));
	const drawerToggle = new DrawerToggle(document.getElementById('drawer-toggle'));
	const snapshots = new Snapshots(document.getElementById('snapshots'));
	const summitSnapshots = new Snapshots(document.getElementById('summit-snapshots'));
	const speakers = new Speakers(document.getElementById('speakers'));
	const youtubeVideoLightbox = new YoutubeVideoLightbox(document.getElementById('youtube-video-lightbox'));
	const vimeoVideoLightbox = new VimeoVideoLightbox(document.getElementById('vimeo-video-lightbox'));
	const mailchimpFormModal = new MailchimpFormModal(document.getElementById('mailchimp-form-modal'));
	const saveTheDateModal = new SaveTheDateModal(document.getElementById('save-the-date-modal'));
	const backToTop = new BackToTop(document.getElementById('back-to-top'));
	const ctaModal = new CTAModal(document.getElementById('cta-modal'));
	const searchPopper = new SearchPopper(document.getElementById('search-popper'));
	const share = new Share();
	const scrollToSummitGallery = new ScrollToSummitGallery();
	const subscriptionSuccess = new SubscriptionSuccess();

	// build initializers
	function initHeroes() {
		const elements = document.querySelectorAll('.gigs-hero');
		elements.forEach(element => {
			const instance = new Hero(element);
			instance.init();
		});
	}
	function initScrollToLinks() {
		const elements = document.querySelectorAll('a[href^="#"]');
		elements.forEach(element => {
			const instance = new ScrollToLink(element);
			instance.init();
		});
	}
	function initGallerySliders() {
		const elements = document.querySelectorAll('.gigs-gallery-slider > .gallery');
		elements.forEach(element => {
			const instance = new GallerySlider(element);
			instance.init();
		});
	}
	function initCarousels() {
		const elements = document.querySelectorAll('.gigs-carousel');
		elements.forEach(element => {
			const instance = new Carousel(element);
			instance.init();
		});
	}
	function initLightboxes() {
		const elements = document.querySelectorAll('.gigs-lightbox');
		elements.forEach(element => {
			const instance = new Lightbox(element);
			instance.init();
		});
	}
	function initMenus() {
		const elements = document.querySelectorAll('.menu');
		elements.forEach(element => {
			const instance = new Menu(element);
			instance.init();
		});
	}
	function initMailchimpForms() {
		const elements = document.querySelectorAll('.gigs-mailchimp-form');
		elements.forEach(element => {
			const instance = new MailchimpForm(element);
			instance.init();
		});
	}

	// Fire right away
	announceEnqueued('site.js');
	subscriptionSuccess.init();
	darkModeToggle.setInitialMode();

	// Fire when document is ready
	window.addEventListener('DOMContentLoaded', event => {
		darkModeToggle.init();
		masthead.init();
		drawerToggle.init();
		backToTop.init();
		youtubeVideoLightbox.init();
		vimeoVideoLightbox.init();
		share.init();
		speakers.init();
		snapshots.init();
		summitSnapshots.init();
		initScrollToLinks();
		initGallerySliders();
		initCarousels();
		initLightboxes();
		initMailchimpForms();
	});

	// fire when document has loaded fully
	window.addEventListener('load', event => {
		initHeroes();
		initMenus();
		searchPopper.init();
		scrollToSummitGallery.init();
		mailchimpFormModal.init();
		saveTheDateModal.init();
		ctaModal.init();
		loader.hide();
	});

})();
